
import { defineComponent } from 'vue';

import CopyToClipboard from '@/components/Muffin/CopyToClipboard';
import ProductCard from '@/components/CheckoutPage/Mobile/Cards/Card';
import BlackRabbitModal from '@/components/BlackRabbit/ModalDesktop.vue';

export default defineComponent({
    components: {
        ProductCard,
        CopyToClipboard,
        BlackRabbitModal,
    },
    props:{
        kStrings:{
            type: Object,
            default: () => {
                return {
                    following: 'Following',
                    follow: 'Follow',
                    copied: 'Copied',
                    campaign: 'Campaign',
                    moreDetails: 'More Details',
                    couponCode: 'Coupon Code',
                    monthCampaign: 'This month campaign'
                }
            }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        campaigns: {
            type: Array,
            default: null
        },
    },
    data(){
        return {
            dktSideProfile: null
        }
    },
    watch:{},
    computed: {
        coupon(){
            if(Array.isArray(this.campaigns) && this.campaigns.length > 0) {
                return this.campaigns[0].coupon ?? undefined;
            }
            return undefined;
        }
    },
    mounted(){
        this.$nextTick(() => {
           this.dktSideProfile = document.getElementById('dktSideProfile');
        });
    },
    methods:{
        async couponCopyClick(coupon) {
            if(this.copiedShow || !coupon){
                return;
            }

            this.copiedShow = true;
            try{
                navigator.clipboard.writeText(coupon);
            }
            catch(err){

            }
        },
        openModal(campaignIdSelected) {
            document.body.style.overflowY = "hidden";
            if(!this.dktSideProfile) {
                this.dktSideProfile = document.getElementById('dktSideProfile');
            }
            this.dktSideProfile.style.zIndex = 1000;
            this.showModal = true;

            setTimeout(() => {
                if(campaignIdSelected) {
                    const headerHeight = (document.querySelector('.promoter-header-box') as HTMLDivElement)?.offsetHeight * 2;
                    const element = document.getElementById(campaignIdSelected);
                    const y = element.getBoundingClientRect().top  + -headerHeight;

                    document.getElementById('scroll-list').scrollTo({
                        top: y, 
                        behavior: 'smooth'
                    });
                }
            }, 500) ;
        },
        onClose(){
            this.dktSideProfile.style.zIndex = 100;
            this.showModal = false;
            this.$emit('close');
            document.body.style.removeProperty('overflow-y');
        },
    }
});
